import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import "dayjs/locale/en-gb";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";

import dayjs from "dayjs";

import EncryptService from "../../service/EncryptionService";

import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";

import { Button } from "@mui/material";

function EditMaterialData() {
  const { state } = useLocation();
  const navigate = useNavigate();
 
  const [poNumber, setpoNumber] = useState("");

 const [poValue, setpoValue] = useState("");
  const [poQuantity, setpoQuantity] = useState("");

  const [billrecDate, setBillRecDate] = useState(null);
  const [getpassnumber, setGetPassNumber] = useState(null);
  const [oldgetpassnumber, setOldGetPassNumber] = useState(null);

  const [formData, setFormData] = useState({
    poNumber: "",
    poValue: "",
    poQuantity: "",
   
  });
  // Update form field values
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "poQuantity" || field === "poValue") {
      validateField(field, value);
    }
  };
  const [indentConsigneeName, setindentConsigneeName] = useState("");
  const validateField = (field, value) => {
    let error = "";
    if (field === "poQuantity" || field === "poValue") {
      if (!value || isNaN(value) || value <= 0) {
        error = `${field} should be more than zero`;
      }
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.poNumber) newErrors.poNumber = "PO Number is required";
       if (
      !formData.poQuantity ||
      isNaN(formData.poQuantity) ||
      formData.poQuantity <= 0
    ) {
      newErrors.poQuantity = "Quantity should be more than zero";
    }
    if (!formData.poValue || isNaN(formData.poValue) || formData.poValue <= 0) {
      newErrors.poValue = "Value should be more than zero";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const today = dayjs();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));


  const handleQuantityChange = (value) => {
    setpoQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
 
  const handleValueChange = (value) => {
    setpoValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };


  const updatePOData = async () => {
    
    let formErrors = {};

   

    if (
      !poQuantity ||
      poQuantity.length === 0 ||
      isNaN(parseFloat(poQuantity)) ||
      parseFloat(poQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (!poValue || isNaN(parseFloat(poValue)) || parseFloat(poValue) <= 0) {
      formErrors.val = "Value should be more than zero";
    }

    if (!poNumber || poNumber.length === 0) {
      formErrors.po = "PO Number Should not be Blank";
    }

    if (!getpassnumber || getpassnumber.length === 0) {
      formErrors.getpass = "New Gate Pass Number Should not be Blank";
    }
    
   
    setErrors(formErrors);

   // console.log(formErrors);
    if (Object.keys(formErrors).length === 0) {
      // const podt = new Date(poDate);
      // const ponewdate =
      //   podt.getFullYear() +
      //   "/" +
      //   parseInt(podt.getMonth() + 1) +
      //   "/" +
      //   podt.getDate();

      const billdt = new Date(billrecDate);
      const Bill_date =
      billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

          

      apiClient
        .post("/receiveditemdataupdate", {
       
         oldgetpassnumber,
         newgetpassnumber:getpassnumber,
          poNumber,
          recDate:Bill_date,
          poQuantity,
          poValue,
          uname,
         ip,
        
        })
        .then(function (response) {
         // console.log(response.data);
          resetData();
          //navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          
            alert(error.response.data.code);
         
        });
    }
  };

  const getPOdata = async () => {
    try {
      const response = await apiClient.post("/getReceivedItembyPONumberGetPassNumber", {
        ponumber: poNumber,
        getpassnumber:oldgetpassnumber,
        uname: uname,
      });

      if (response.status === 201 && response.data?.length > 0) {
        const poData = response.data[0]; // Use directly

console.log(poData);


        setpoQuantity(poData.ItemQuantity || "");
        setpoValue(poData.ItemValue || "");
        setBillRecDate(dayjs(poData.itemReceivedDate || null));
        setGetPassNumber(poData.getpassnumber || "");

      } else {
        alert("Invalid PO Number");
      }
    } catch (error) {
    //  console.error("Error fetching PO data:", err);
      //alert("Check Entered Data and try again.");
       const errorMsg = error?.response?.data?.message || error.message || "Unknown error occurred";
       alert("Error fetching data: " + errorMsg);
      resetData();
    }
  };

 

  const resetData = async () => {
  
    setpoNumber(null);
    setOldGetPassNumber(null)
    setpoQuantity(null);
    setpoValue(null);
    setBillRecDate(null);
    setGetPassNumber(null);
    



  };

    const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

 return (
  <>
    <style>{`
      .edit-material-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        background: #f4f8fc;
        overflow-x: hidden;
      }

      .edit-material-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #dbe7f3;
        border-radius: 16px;
        box-shadow: 0 6px 22px rgba(13, 71, 161, 0.10);
        overflow: hidden;
      }

      .edit-material-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .edit-material-header::before {
        content: "📦";
        font-size: 20px;
      }

      .edit-material-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 20px;
      }

      .edit-material-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 16px;
        margin-bottom: 16px;
        background: #fbfdff;
        border: 1px solid #e0eaf5;
        border-radius: 12px;
      }

      .edit-material-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dce8f5;
        color: #0d47a1;
        font-size: 15px;
        font-weight: 700;
      }

      .edit-material-section-title::before {
        content: "";
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: linear-gradient(
          180deg,
          #0d47a1,
          #1976d2
        );
      }

      .edit-material-search-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns:
          minmax(0, 1fr)
          minmax(0, 1fr)
          auto;
        gap: 14px;
        align-items: center;
      }

      .edit-material-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      .edit-material-field {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .edit-material-field .MuiFormControl-root {
        width: 100%;
        max-width: 100%;
      }

      .edit-material-field .MuiInputBase-root {
        background: #ffffff;
      }

      .edit-material-field .MuiOutlinedInput-root:hover fieldset {
        border-color: #1976d2;
      }

      .edit-material-field .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #1565c0;
        border-width: 2px;
      }

      .edit-material-search-action {
        min-width: 110px;
      }

      .edit-material-search-button {
        width: 100%;
        min-height: 42px !important;
        border-radius: 8px !important;
        text-transform: none !important;
        font-weight: 700 !important;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        ) !important;
        box-shadow: 0 3px 8px rgba(13, 71, 161, 0.20) !important;
      }

      .edit-material-search-button:hover {
        box-shadow: 0 5px 12px rgba(13, 71, 161, 0.28) !important;
      }

      .edit-material-actions {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: flex;
        justify-content: flex-end;
        margin-top: 4px;
      }

      .edit-material-update-button {
        width: 180px;
        max-width: 100%;
        min-height: 44px;
        padding: 10px 20px;
        border: none;
        border-radius: 9px;
        color: #ffffff;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 10px rgba(13, 71, 161, 0.20);
        transition: all 0.2s ease;
      }

      .edit-material-update-button:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(13, 71, 161, 0.28);
      }

      .edit-material-update-button:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
      }

      .edit-material-info {
        width: 100%;
        box-sizing: border-box;
        padding: 9px 12px;
        margin-top: 10px;
        border-radius: 7px;
        background: #eaf3ff;
        border: 1px solid #cfe2f8;
        color: #0d47a1;
        font-size: 12px;
        font-weight: 600;
      }

      @media (max-width: 900px) {
        .edit-material-search-grid {
          grid-template-columns:
            minmax(0, 1fr)
            minmax(0, 1fr);
        }

        .edit-material-search-action {
          grid-column: 1 / -1;
          min-width: 0;
        }

        .edit-material-search-button {
          width: 100%;
        }
      }

      @media (max-width: 650px) {
        .edit-material-page {
          padding: 8px;
        }

        .edit-material-card {
          border-radius: 12px;
        }

        .edit-material-header {
          padding: 13px 15px;
          font-size: 16px;
        }

        .edit-material-content {
          padding: 12px;
        }

        .edit-material-section {
          padding: 12px;
          margin-bottom: 13px;
        }

        .edit-material-search-grid,
        .edit-material-grid {
          grid-template-columns: minmax(0, 1fr);
          gap: 13px;
        }

        .edit-material-search-action {
          grid-column: auto;
        }

        .edit-material-actions {
          display: block;
        }

        .edit-material-update-button {
          width: 100%;
        }
      }

      @media (max-width: 380px) {
        .edit-material-page {
          padding: 5px;
        }

        .edit-material-content {
          padding: 9px;
        }

        .edit-material-section {
          padding: 10px;
        }

        .edit-material-header {
          font-size: 15px;
        }
      }
    `}</style>

    <div className="edit-material-page">
      <div className="edit-material-card">

        {/* Header */}
        <div className="edit-material-header">
          Edit Received Material Data
        </div>

        <div className="edit-material-content">

          {/* Search */}
          <div className="edit-material-section">

            <div className="edit-material-section-title">
              Search Received Material
            </div>

            <div className="edit-material-search-grid">

              <div className="edit-material-field">
                <CustomTextField
                  label="PO Number (Max 20 Character)*"
                  value={poNumber || ""}
                  onChange={handleChange}
                  placeholder="PO Number (Max 20 Character)*"
                  maxLength={20}
                  error={!!errors.po}
                  helperText={errors.po}
                />
              </div>

              <div className="edit-material-field">
                <CustomTextField
                  label="Old Gate Entry Pass Number / Memo Number / Invoice Number"
                  value={oldgetpassnumber ?? ""}
                  onChange={(e) => {
                    setOldGetPassNumber(e.target.value);
                  }}
                  placeholder="Old Entry Pass Number / Memo Number / Invoice Number"
                  maxLength={50}
                />
              </div>

              <div className="edit-material-search-action">
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={getPOdata}
                  disabled={!(oldgetpassnumber && poNumber)}
                  className="edit-material-search-button"
                >
                  Search
                </Button>
              </div>

            </div>
          </div>

          {/* Material Details */}
          <div className="edit-material-section">

            <div className="edit-material-section-title">
              Received Material Details
            </div>

            <div className="edit-material-grid">

              <div className="edit-material-field">
                <NumericTextField
                  id="ItemQuantity"
                  label="Item Quantity"
                  title="Item Quantity"
                  error={errors.qty}
                  value={poQuantity || ""}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="edit-material-field">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={poValue || ""}
                  onChange={handleValueChange}
                />
              </div>

              <div className="edit-material-field">
                <CustomTextField
                  label="New Gate Entry Pass Number / Memo Number / Invoice Number"
                  value={getpassnumber ?? ""}
                  onChange={(e) => {
                    setGetPassNumber(e.target.value);
                  }}
                  placeholder="New Entry Pass Number / Memo Number / Invoice Number"
                  maxLength={50}
                  error={!!errors.getpass}
                  helperText={errors.getpass}
                />
              </div>

              <div className="edit-material-field">
                <DatePickerComponent
                  label="Item Receiving Date"
                  id="itemreceivingdate"
                  value={billrecDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setBillRecDate
                    )
                  }
                />
              </div>

            </div>
          </div>

          {/* Update */}
          <div className="edit-material-actions">
            <button
              className="edit-material-update-button"
              type="button"
              onClick={updatePOData}
              title="Click for Update Data"
              disabled={!getpassnumber}
            >
              ✓ Update Data
            </button>
          </div>

        </div>
      </div>
    </div>
  </>
);
}


export default EditMaterialData